import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M4.364 10.027a5.684 5.684 0 0 0 3.78 5.31c.396.143.576.363.573.7-.005.49-.461.797-.953.633a6.8 6.8 0 0 1-2.537-1.515C4 14.001 3.26 12.582 3.058 10.913c-.255-2.108.33-3.982 1.742-5.574C5.965 4.026 7.445 3.28 9.18 3.056c3.408-.441 6.713 1.776 7.608 5.088.115.426-.075.803-.461.914-.385.11-.74-.118-.873-.537-.715-2.276-2.25-3.656-4.598-4.061-2.969-.512-5.891 1.616-6.38 4.595-.052.321-.075.648-.112.972Z"
        />
        <path
            fill="currentColor"
            d="M13.465 9.19a2.222 2.222 0 0 1 2.243 2.241c0 1.226-1.015 2.227-2.253 2.222a2.252 2.252 0 0 1-2.248-2.25c.005-1.23 1.012-2.216 2.258-2.214Zm.004 1.284c-.541-.002-.98.424-.976.948.003.515.448.95.966.947a.959.959 0 0 0 .963-.946.942.942 0 0 0-.953-.949ZM9.928 16.148a1.928 1.928 0 0 1 1.975-2.011c1.036.015 2.073.001 3.11.004 1.164.002 1.989.831 1.987 1.997 0 .129 0 .261-.03.385a.632.632 0 0 1-.701.471.647.647 0 0 1-.554-.622c-.006-.153.002-.31-.027-.459a.595.595 0 0 0-.524-.478 1.886 1.886 0 0 0-.258-.013c-.956 0-1.913.014-2.869-.007-.529-.011-.875.253-.828.824.027.315-.088.573-.394.707a.633.633 0 0 1-.887-.563c-.004-.086 0-.172 0-.235ZM10.713 8.54c0 .624.002 1.247 0 1.87-.002.48-.267.75-.741.752-.994.003-1.989.003-2.983 0-.39-.002-.656-.24-.71-.619-.044-.313.176-.64.499-.731a.984.984 0 0 1 .256-.026c.698-.001 1.396-.006 2.094.003.162.002.21-.042.21-.207-.008-.987-.008-1.974-.003-2.962.003-.507.44-.831.904-.681.292.094.471.343.473.677.003.642.001 1.283.001 1.925Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
